import { render } from "./Login.vue?vue&type=template&id=1aa5a510&bindings={\"instanceUrl\":\"data\",\"handleUserLogin\":\"options\"}"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script